import React, { useRef, useEffect } from "react";
import config from "../../config/GraphViewConfig";
import Point from "../../structures/Point";
import "./styles.css";

const Edge = ({ edge, curved = true, isHighlightEdge = false, isHighlighted }) => {
    const pathRef = useRef(null);

    if (edge.points.length < 2) return null;

    let pathData = "";
    const radius = config.design.edgeCurveRadius;

    if (curved && edge.points.length > 4) {
        const newPoints = [edge.points[0]];
        for (let i = 1; i < edge.points.length - 1; i++) {
            const prev = edge.points[i - 1];
            const curr = edge.points[i];
            const next = edge.points[i + 1];
            const horizontal = prev.y === curr.y && curr.y === next.y;
            const vertical = prev.x === curr.x && curr.x === next.x;

            if (horizontal || vertical) {
                newPoints.push(curr);
                continue;
            }

            const dx1 = curr.x - prev.x;
            const dy1 = curr.y - prev.y;
            const dx2 = next.x - curr.x;
            const dy2 = next.y - curr.y;

            const dist1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            const dist2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            const effectiveRadius = Math.min(radius, dist1 / 2, dist2 / 2);

            const entry = new Point(
                curr.x - Math.sign(dx1) * (Math.abs(dx1) > 0 ? effectiveRadius : 0),
                curr.y - Math.sign(dy1) * (Math.abs(dy1) > 0 ? effectiveRadius : 0)
            );

            const exit = new Point(
                curr.x + Math.sign(dx2) * (Math.abs(dx2) > 0 ? effectiveRadius : 0),
                curr.y + Math.sign(dy2) * (Math.abs(dy2) > 0 ? effectiveRadius : 0)
            );

            newPoints.push(entry);
            newPoints.push(curr);
            newPoints.push(exit);
        }

        newPoints.push(edge.points[edge.points.length - 1]);

        pathData = `M ${newPoints[0].x} ${newPoints[0].y}`;
        for (let i = 1; i < newPoints.length - 2; i++) {
            const p1 = newPoints[i];
            const p2 = newPoints[i + 1];
            const p3 = newPoints[i + 2];

            if (edge.points.some(p => p.x === p2.x && p.y === p2.y)) {
                pathData += ` L ${p1.x} ${p1.y} Q ${p2.x} ${p2.y} ${p3.x} ${p3.y}`;
                i += 2;
            } else {
                pathData += ` L ${p1.x} ${p1.y}`;
            }
        }

        const last = newPoints[newPoints.length - 1];
        pathData += ` L ${last.x} ${last.y}`;
    } else {
        pathData = edge.points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
    }

    useEffect(() => {
        const path = pathRef.current;
        if (!path) return;

        const totalLength = path.getTotalLength();
        path.style.strokeDasharray = totalLength;

        if (!isHighlightEdge){
            path.style.transition = "none";
            path.style.strokeDashoffset = totalLength;

            path.getBoundingClientRect();

            path.style.transition = "stroke-dashoffset 1.2s ease-out";
            path.style.strokeDashoffset = 0;
        }

    }, [edge.points, pathData]);

    useEffect(() => {
        if(!isHighlightEdge)return;
        const path = pathRef.current;
        if (!path) return;

        const totalLength = path.getTotalLength();

        path.style.transition = "none";
        path.style.strokeDasharray = totalLength;
        path.style.strokeDashoffset = isHighlighted ? totalLength : 0;

        if (isHighlighted) {
            path.getBoundingClientRect();
            path.style.transition = "stroke-dashoffset 1s ease-out";
            path.style.strokeDashoffset = 0;
        } else {
            path.style.transition = "stroke-dashoffset 0.3s ease-in";
            path.style.strokeDashoffset = totalLength;
        }
    }, [isHighlighted, edge]);

    return (
        <path
            ref={pathRef}
            d={pathData}
            fill="none"
            markerEnd="url(#arrowhead)"
            className={'graph-edge' + (isHighlighted ? ' highlighted' : '')}
        />
    );
};

export default Edge;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/components/Edge/index.jsx